import React, { MouseEvent, ReactNode } from 'react'

import { ButtonItem } from './styles'

interface AddButtonItemProps {
  title: ReactNode
  onSelect: (ev: MouseEvent) => void
}

const AddButtonItem = ({ title, onSelect }: AddButtonItemProps) => {
  return <ButtonItem onClick={onSelect}>{title}</ButtonItem>
}

export default AddButtonItem
